const Header = () => {
    return (
        <h1>
            <span className='badge bg-dark'>todo</span>
            <small className='text-muted'>app</small>
        </h1>
    );
};

export default Header;